import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import {api} from '../../api';


export default function ContactPicker({ selected = [], onChange }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const search = useCallback((q) => {
    if (!q || q.length < 2) { setResults([]); return; }
    api(`/contacts?q=${encodeURIComponent(q)}`)
      .then(r => r.json())
      .then(data => setResults(data.filter(c => !selected.some(s => s.id === c.id))))
      .catch(() => {});
  }, [selected]);

  useEffect(() => {
    const timer = setTimeout(() => search(query), 250);
    return () => clearTimeout(timer);
  }, [query, search]);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const add = (contact) => {
    onChange([...selected, { id: contact.id, firstName: contact.firstName, lastName: contact.lastName }]);
    setQuery('');
    setResults([]);
  };

  const remove = (id) => {
    onChange(selected.filter(c => c.id !== id));
  };

  return (
    <div ref={ref} className="relative">
      <div className="flex flex-wrap gap-2 mb-2">
        {selected.map(c => (
          <span key={c.id} className="inline-flex items-center gap-1 px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm">
            <Link to={`/crm/contacts/${c.id}`} className="hover:underline">{c.firstName} {c.lastName}</Link>
            <button type="button" onClick={() => remove(c.id)} className="text-blue-400 hover:text-blue-600 ml-1">&times;</button>
          </span>
        ))}
      </div>
      <input
        type="text"
        placeholder="Search contacts by name or title..."
        value={query}
        onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
      />
      {open && results.length > 0 && (
        <ul className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
          {results.map(c => (
            <li key={c.id}>
              <button type="button" onClick={() => { add(c); setOpen(false); }} className="w-full text-left px-4 py-2 hover:bg-gray-50 text-sm">
                {c.firstName} {c.lastName}
                {c.emails && c.emails.length > 0 && (
                  <span className="text-gray-400"> — {c.emails[0].email}</span>
                )}
                {c.companies && c.companies.length > 0 && (
                  <span className="text-gray-400"> · {c.companies.map(co => co.title ? `${co.title} at ${co.companyName}` : co.companyName).join(', ')}</span>
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
      {open && query.length >= 2 && results.length === 0 && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg px-4 py-3 text-sm text-gray-500">
          No contacts found
        </div>
      )}
    </div>
  );
}
